export default link => ({
  dynamicLinkInfo: {
    domainUriPrefix: 'https://member.ollaa.app',
    link,
    androidInfo: {
      androidPackageName: 'com.ollaa.app',
      androidFallbackLink: link,
    },
    iosInfo: {
      iosBundleId: 'de.ollaa.Ollaa',
      iosFallbackLink: link,
    },
    socialMetaTagInfo: {
      socialTitle: 'Deine Einladung zu Ollaa wartet!',
      socialDescription: 'Du wurdest zu einer kostenlosen Bartour eingeladen! Bist du dabei? Angebot begrenzt.',
      socialImageLink: 'https://api.ollaa.app/image/invitation/thumbnail',
    },
  },
  suffix: {
    option: 'UNGUESSABLE',
  },
});
